import Marquee from "react-fast-marquee";

// Slow editorial outline marquee.
export const EditorialMarquee = ({ items = [], dark = false, speed = 30 }) => {
  return (
    <div className="py-10 border-y border-ink/10 overflow-hidden select-none">
      <Marquee speed={speed} gradient={false} autoFill>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display font-800 text-5xl md:text-7xl lg:text-8xl px-8 tracking-tight ${
                dark ? "text-stroke-light" : "text-ink/15"
              }`}
            >
              {item}
            </span>
            <span className="text-teal text-4xl md:text-6xl px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
